/**
 * 课程管控类型，0-弱管控，1-强管控
 */
export const COURSE_CONTROL_TYPE = {
    WEAK: 0,
    FORCE: 1,
};

/**
 * VSS账户类型：目前有2种账户类型，0: 商品供应商账户，1: 劳动力供应商账户。 一个账号可以同时拥有 2 个账户类型。
 */
export const VSS_ACCOUNT_TYPE = [
    {
        label: '商品供应协同平台',
        code: 0,
        to: '/index.html',
    },
    {
        label: '劳动力协同平台',
        code: 1,
        to: '/renxiao/index.html',
    },
];

export const SUPPLIER_AUTH_STATE = {
    PENDING: 'pending',
    NO: 'no',
    YES: 'yes',
};
